import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { MEDIA_CONTENT_PLACEMENT, MEDIA_TYPES } from '../../constants';
import { getPlatformInfo } from './platformsActions';

export const makePlatformsCacheKey = (type = MEDIA_TYPES.IMAGE, placement = MEDIA_CONTENT_PLACEMENT.SINGLE) =>
  `${type}:${placement}`;

const resolveCacheKeyFromArg = (arg = {}) => {
  const type = arg.type ?? MEDIA_TYPES.IMAGE;
  const placement = arg.placement ?? MEDIA_CONTENT_PLACEMENT.SINGLE;

  return makePlatformsCacheKey(type, placement);
};

const initialState = {
  byKey: {},
  loadingByKey: {},
  activeKey: null,
};

const platformsSlice = createSlice({
  name: 'platforms',
  initialState,
  reducers: {
    resetPlatforms: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isAnyOf(getPlatformInfo.pending), (state, action) => {
        const key = resolveCacheKeyFromArg(action.meta.arg);
        state.loadingByKey[key] = true;
        state.activeKey = key;
      })
      .addMatcher(isAnyOf(getPlatformInfo.fulfilled), (state, action) => {
        const key = resolveCacheKeyFromArg(action.meta.arg);
        state.byKey[key] = action.payload;
        state.loadingByKey[key] = false;
        state.activeKey = key;
      })
      .addMatcher(isAnyOf(getPlatformInfo.rejected), (state, action) => {
        const key = resolveCacheKeyFromArg(action.meta.arg);
        state.byKey[key] = {};
        state.loadingByKey[key] = false;
      });
  },
});

export const selectPlatformsForKey = (state, key) => state.platforms.byKey[key] ?? {};

export const selectIsPlatformsLoading = (state, key) => Boolean(state.platforms.loadingByKey[key]);

export const selectIsAnyPlatformsLoading = (state) => Object.values(state.platforms.loadingByKey).some(Boolean);

export const { resetPlatforms } = platformsSlice.actions;

export default platformsSlice.reducer;
